var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-pn",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h320v240H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 96.5v48h320v-48zM136.5 0v240h48V0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M410.1 252.3a56.5 56.5 0 0 0-19 27.8c-5.7 27.3-13.3 33.4-25 27.5 0 14.7 12.9 15.8 18.5 7.3 0 13.7 5 25.6 16.2 35.8 4.8 4.3 5.7 1.4 3.4-3.4-2.2-4.7-2.2-20-6.7-28.8 7.2 5.1 17.8 2.2 17-12-9.3 5.4-18.5 5.2-19.5-7.7-1.1-15 4.7-37 15.1-46.5zM399.1 143.7c.7-5.5-.5-11-4.5-14.5-7.6-6.7-15.1-4.5-20.7 1-8.3-4.6-12.8 11.4-22.2 8.7 1.5 5.2 4 7.4 8.8 5.6-5 4.5 0 10-5.9 15.4 10.6 3.4 16.2-2.5 15.8-12.7a9.6 9.6 0 0 0 13.7-.7c-5.6-1.8-5.6-6.7-3.4-11.2 3.4-6.8 19.3-6.5 18.4 8.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M423.6 222.1c-12 6.4-33.8 3.7-35.9-12-2-15.5 13.1-22.5 17.2-24.5 6.3-3.2 11.3 2.5 9.2 9 7-2.4 8.6-10.6 5.2-15.3 9.3.7 17.8-6.3 21.4-16.2-3.2 3-12 1-19.3.5 2.2-2.5 2.2-7.3 1.5-9.8-7.6 7.9-18.7 4.3-33.3 27a1023.3 1023.3 0 0 0 9.6-37.1c.8-15-15-15.2-18.4-8.4 3.7 4.2 1.7 9 .4 16.5-1.6 8.7-5 29-7.9 35.8-.9-10.6-7.9-11.3-9.2-16.5-2 1.4-3.2 5-2.7 7.5-2.5-2.7-11.1.7-14.3-3.4-3.3 6.7 2 13.5 7.7 16.5-3.3.2-4 4.1-7.7 4.1 4.9 5.7 9.9 8 15.6 8.4 5.8.4 10 2.6 13.5 9.6 5.7 11.3 27.2 18.6 47.4 8.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M453.4 208.4c-6.8 18.7-25.3 32-33.6 34-14.2 3.5-43.2 17.6-51 24.8a9 9 0 0 1-3.2-1.3c-3.8-2.7-7-11.5-.2-19 21.2-19.8 44-11.2 58.2-24.8-12 6.3-33.8 3.6-35.8-12a55 55 0 0 0 54.5-16.2 97.7 97.7 0 0 1 11 14.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M410.1 252.3c-10.7 9-16.2 31.4-15.1 46.5.3 4.2 1.5 7 3.3 8.8.8-8.6 6.7-30.7 22-40.6 12.8-8.3 32.9-27 40.3-48.5a17.2 17.2 0 0 0-7.9-9.2c-7.4 20.2-27.1 29.9-42.6 43z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#316d3a",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M446.5 199.7a50.3 50.3 0 0 1-20.9 16.8 11 11 0 0 0 2.5-6.8 76.9 76.9 0 0 1-40.4.5 55 55 0 0 0 54.6-16.2 21 21 0 0 1 4.2 5.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M365.4 247c-17.2 16-5.8 30.2 1 33.3-1.9 11.3 8.7 10 8.5 19.4 4.3-2.4 5.4-9 4.7-14.2 5.5 5.9 19.2-.7 22.1 10.2 1.9-12-7.4-24-18.9-22.8 4.8-4.3 2-11.3-2.5-13.1-.9 8.8-10.8 8.8-14.6 6-3.9-2.6-7-11.4-.3-18.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M402.7 349.6c-1.8 1-1.7 3.5-.5 5 2.3 3.2-1.7 10.4 6 11.9 2.2.5 4-1 4.8-3.5 2.4-7.1-5.2-7.9-5.9-11.3-.6-3.4-2.8-3-4.4-2.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M409.2 362.9c-2.5 1.2-4.8 2.8-3.7 11 .4 3.3.2 11.4-2.8 11.5 1.8 1 5.7 2 7.3-.2 1.5 2.6 5 1.8 6.3-1.3 1.8 1.4 4.3-1 4.3-3.2 1.5 1 4.7-.4 3.9-5.3 2 .7 4.4-.7 5.3-1.9-2.8-.6-10-4.4-11.6-7.4-1.7-3.1-6-4.6-9-3.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M370 134.7c1.2-1.6 2.5-3.2 4-4.6M413 164.6c2-1.1 5-1.3 8.4-1M410 385.2c-.8-1.1-1.1-5.8-.6-8.7M416.3 383.9c-1.3-1-3.6-4.3-4-7.1M420.6 380.7a19 19 0 0 1-6.3-8.9M424.5 375.4c-1.9-.4-7.6-4.1-10-8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M528.5 247.2c27.7 23.2 29.5 41.7 25.3 52.5-2.3-10.1-13.8-25.9-25.8-30z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M478.9 234h51.4v61c0 51.9-28.8 82.5-58.2 98.8A108.3 108.3 0 0 1 414 295v-61h36c0 3.2.4 8 4 12.7 8.6-.8 18.2-7.2 24.9-12.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#006ec7",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M530.3 234v61c0 15.6-2.6 29.4-7 41.3L472 242.6l-51 93.7c-4.5-12-7.1-25.7-7.1-41.3v-61z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "M524.8 331.9a116 116 0 0 1-3.8 10L472 251l-48.7 91c-1.3-2.8-2.9-7.3-3.8-10l52.7-97.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m495.3 365.3 5 2.3a36 36 0 0 0 2.2-19.8c-2.9 7.4-12.8 7.2-15.5 11.7 1.6.8 3.2 2 4.5 2.9-3.4 3.4-11.3 9-15.8 10.4v-48.4c0-3.4-1.2-6.2-1.2-9v-10c0-2.3-.4-5.6-2.4-5.6s-2.5 3.3-2.5 5.6v10c0 2.8-1.1 6-1.1 9v48.4c-2.5-7.2-12.2-4.8-16.7-12a14 14 0 0 1 5.4-.2c-3.4-11.5-12.7-12.4-14.4-15.8 0 4.8-2 15.8 1.1 20.6.7-.9 1.8-1.8 3-2.5 3.9 8.3 21.1 8.3 25.2 22.1 3.3-5 15-11 23.2-19.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M472.1 325c3.8 0 16-1.2 20.4-1.2 1.2 0 2.1-1.8 2.1-3.9 0-2-.9-3.8-2-3.8-4.5 0-16.6-1.2-20.5-1.2-3.8 0-16 1.2-20.4 1.2-1.2 0-2.1 1.7-2.1 3.8 0 2.1 1 3.9 2 3.9 4.5 0 16.7 1.2 20.5 1.2zM469.6 305.2c-.8-.7-1.8-1-3-1-2.6 0-4.7 1.8-4.7 4.1 0 2.4 2.1 4.3 4.7 4.3 2.5 0 4.6-2 4.6-4.3 0-1.8 2.6-1.8 2.6 0 0 3.7-3.2 6.7-7.2 6.7s-7.3-3-7.3-6.7c0-3.6 3.3-6.6 7.3-6.6a8 8 0 0 1 3.3.8c0 .6-.3 1.7-.3 2.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M451.7 323.8c1.1 0 2-1.8 2-3.9 0-2-.9-3.8-2-3.8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M453.4 323.8c1.1 0 2-1.8 2-3.9 0-2-.9-3.8-2-3.8M464.5 324.5c1.4 0 2.5-2 2.5-4.6 0-2.5-1-4.6-2.5-4.6M467.1 324.7c1.5 0 2.6-2.1 2.6-4.8 0-2.7-1.1-4.8-2.6-4.8M475.8 324.8c1.5 0 2.6-2.2 2.6-4.9s-1.2-4.9-2.6-4.9M478.5 324.6c1.4 0 2.6-2 2.6-4.7 0-2.6-1.2-4.7-2.6-4.7M490.6 323.8c1.2 0 2.1-1.7 2.1-3.9s-.9-4-2-4M447 362.9c1.3-.9 3-1.6 4.8-2M492.9 363.3l-1.4-1M495.3 365.3c3.2-3.4 5.8-7.3 7.3-11.7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M461.8 277.2c0-1.2.9-1.6 2-2.4 1.2-1 1.7-1.4 2.9-1.4h14.8c1 0 1.3.3 1.3 1.3v20c0 1-.2 1.4-1.3 1.4h-19.7v-19.2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M477.8 297.8c2 0 1.6 0 3-1.4s1.3-1.3 1.3-2.6v-18.4c0-1-.3-1.2-1.3-1.2h-13.7c-1 0-1.5.4-2.7 1.3-1 .8-1.8 1.2-1.8 2.2v20.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M479.3 297.4c0 1-.3 1.3-1.4 1.3h-14.8c-1.1 0-1.3-.3-1.3-1.3v-20.1c0-1 .2-1.3 1.3-1.3h14.8c1.1 0 1.4.3 1.4 1.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M508 222.3c2.8 3.2 3.8 7.5 2.2 11.8H506c1.8-5.5.7-10.6-7-11.3-11.4-1-24.8 21.2-44.9 23.9-5.8-7-5.5-20.3 2-26.6a82 82 0 0 0-17.7-28.6 55 55 0 0 0-10.7-.7c3-6.4 11.3-13 18.1-15.7a82 82 0 0 1 3.4-4.5c.7-8.7 42-4.7 50.7.7 0 9.8 3.9 42.2 8.2 51z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M458 228.2c-1-15-7.1-27.4-15.7-35.8a23.5 23.5 0 0 0 18-3c7.5-5 27-13.6 34-9.9.6 1.3 1 4 .5 5.9-1.7-4.5-20.4 2.4-25.7 4.6-5 2.3-7.3 5.5-5.5 12.6-3-2.5-2-4.8-5-6.6 1.2 2.9 2.2 8.2 2.6 12.5-1.2-3-3.2-9.6-7.6-13.5a74.2 74.2 0 0 1 5.6 34.8c3 0 9.8-3 12.4-5-2.3 3.3-9.2 5.7-13.5 6.6a22 22 0 0 0-3.3 11.8c-.3-4.2 1-14.3 3.1-15zM508 222.3c-3.8-4.2-10.7-6.4-19.6-4a28 28 0 0 1 6.8-2.3c-.3-2.3-2.4-12.5-2.8-15l2.5-1c1.3 6.1 2.8 13.1 3.8 16 .8.1 2.6.5 4.2 1.3-.7-2.4-4.5-19.4-4.4-21.2l3.4-1.8a138 138 0 0 0 6 28z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M506 234c1.7-5.3.6-10.5-7-11.2-6-.5-12.4 5.3-20 11.3zM456.1 185.5a45 45 0 0 1-14.8-1.5c.2-1 .6-2 1.1-3.2a47 47 0 0 0-8.5 6.8c5.4 1.2 16.6 1.7 22.2-2.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M456 220c1.2 3.7 2 7.2 2.1 10.3M445.7 175.1c-2 3-3.8 6.2-4.4 9a47.6 47.6 0 0 0 14.8 1.4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M438.4 191.5c1.4.3 2.8.5 4 .9 4 1.1 12.3 1.1 18-3 5.6-4 21-16.7 38.3-18"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M433.9 187.6c5.4 1.2 16.6 1.7 22.2-2.1a76.1 76.1 0 0 1 38.4-14.8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M528.5 247.2c19 13 33 25.7 37 46s11.7 25.7 21.2 20.3c-2.2 11.7-14 13-23.9 4 1 13.6-4.5 29.8-18.5 35.7-.9-8.1 4.5-14.6 3-21.2-.7-3-1-9.7 2.9-12.9-7.5 2.5-19.2-2.2-20.3-13.3 8.6 4 19.6 4.7 23.9-6.1 4.2-10.8 2.4-29.3-25.3-52.5zM552.4 141.6c5.9-15.3 21.2-13.7 26.4-7.2 15.1-8.6 17.2 10.8 30 7-.2 3.6-4.5 7-9.2 6.7 5 4.5-2 11.3 8.5 15.4-9 4.5-21.6-.2-25-12.7-3 5.9-13.5 5.9-17.8 1.2 9.2-2.5 8.6-11 3.4-14.5-5.3-3.4-14.5-2-16.3 4.1zM506.7 175.4a82.2 82.2 0 0 0 22.3 34.8c10.8 10 27.1 7.4 36.3-2 .2 18.8-19.4 20.3-30.2 14.4-4.8-2.6-8.7-1.3-4.1 3 7 6.2 22.3 11 40.4 14.8 31.5 6.8 20.3 31.8 11 31.6 2.7 0 4.9-2.9 1-6.3-27.4-24.7-83-15-82.2-70-5.8 14.5-30 8.8-18.7-8.3 3.6 2.9 10 3.1 11.7-1.4 1.4-3.5.5-9.6-5.8-14.9 1 0 3.3 0 3-2.6.3 1.6 1.7 3.8 5.3 3 1 1.7 2 2.7 3.5 2.1.3 0 1.1-.5.8-2.1.2 3 3.8 4.1 5.7 3.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M535 222.6c13.1 8.5 28 8.5 41.5-7.2 4.3-5 11-9.3 15.8-9.7 4.8-.5 4.5-5 8.1-6-2.2-.6-3.1-3.3-6.5-3 8.5-2.9 6-9.7 10.1-13-3.4 1.3-8.6-3.7-13.5 2.7 1.3-3-.5-6.4-1.7-7.8.5 3.4-6.6 4-8 12.6-.7 4.8-3.4 4.6-3.8-2.9-.3-5.4-3-20.5-6-28.2-3.2-7.6-4-18.2.3-19.7a7.7 7.7 0 0 0-2.6-2.8c-5.3-3.4-14.5-2-16.3 4-5.8 15.4 10.6 24.2 9.3 40.9-2.5-12.4-22.6-15.6-22.4-27.8-6.5 3-5.6 8.4-3.1 12.7-4-6.3-13.3 4-21.2-4.5-1 11.3 9 15.5 17.1 16-4 7.2 1.4 13.3 6.8 15.3.2-12.6 26.1-7.5 26.4 14.2.2 18.5-19.7 20-30.3 14.2zM571.4 240.4c31.5 6.8 20.3 31.8 11 31.6-5.9-.2-11.5-5.1-11.8-9.4-6.8 3.6-5 10.7.2 13.5-14.2-1.6-20.2 7.7-20.5 18 2.6-4.8 10.4-5 13.4-4s10.5 1.5 13.5-2c-2.5 2.2 1.6 7.2-2 11 12-.4 17.1-11.5 15-16.3 15.4-14 12.5-36.8-18.8-42.4zM547.3 347.6c2 1.2 1.8 4 .4 5.7-2.8 3.4 1.4 11.5-7.2 13-2.5.3-4.4-1.3-5.2-4.2-2.4-8 6.1-8.6 7-12.3 1-3.8 3.3-3.3 5-2.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M539.6 362.1c2.7 1.4 5.1 3.4 3.7 12.4-.7 3.7-.8 12.8 2.5 13-2 1-6.4 1.9-8-.5-1.9 2.8-5.7 1.8-7-1.8-2.2 1.6-4.8-1.3-4.7-3.7-1.8 1-5.3-.7-4.2-6-2.2.6-4.9-1-5.8-2.4 3.1-.6 11.2-4.5 13.3-7.8 2-3.4 7-4.8 10.2-3.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M537.7 387c1-1.2 1.5-6.5 1-9.7M530.7 385.2c1.5-1 4.2-4.5 4.8-7.7M526 381.5a22 22 0 0 0 7.4-9.7M521.9 375.5c2-.4 8.6-4.3 11.4-8.6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M501.2 195.8c-.4 23 9.2 34.8 22.6 42.4-5-3-2.8-13.1-9.5-16.4 1.6-.1 4 2.1 8 1.2-2-4.2-5-10.8-12.4-11.7 2-.2 6 .5 8.8-.5-3.8-6-14-3.1-17.5-15zM498.8 173.8c-.8-.3-1.5-1.1-2.1-2.2-3.6.8-5-1.5-5.3-3 .3 2.6-2 2.5-3 2.6 6.3 5.2 7.2 11.3 5.8 14.8-1.8 4.5-8 4.3-11.7 1.4-.5 9.6 12 12.7 16.5.7 0 2 2.6 1.8 3.2 4.5 3.2-5.2.8-12.7-3.4-18.8z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M479 128a27 27 0 0 1-8-18.9c.2-5 2.2-10.3 9.5-8-2.3 0-.7 4.4-3 4.9 1.8.7 4.4-.9 4.8-2 .4 1.6 3.4 1.2 3.6 3 1.1-.9-.1-5.3-1.8-6.2 1.2-.7 2-4.2 1.4-5.9-1.2.2-2.9 1.8-3.2 4.1.6-1.8-.1-6.3-3.3-7-.9 1.2-1.1 4.3.1 6-2.9-.7-7.2 1.2-8.2 3.7.2-3 .6-7.3 2.5-10 .6-.8-1-2.4-2.1-.3-2.2-4.3-8-6.5-10.7-4.4-2.6 2.2-6-1-8.2 2.4-2.1 3.4-9.4 3.7-9 7.3.2 2.2-.3 5.5-1.4 6.7-2.6 2.9 1.3 5 2 7.6-.5-8.5 13.1-25.2 26.8-18.7a30.2 30.2 0 0 0-2.7 11.6c-.6 7.7.6 18.5 8 24.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M483 101.1c0-2 3.5-4.7 8.2-4.6 5.7 0 10 5.2 14.6 4.7s2.4 2 1.4 2.8c-1 .6-1.5 1.6-1.2 2.9.3 1.2-.2 2-2 .9-4.1-2.6-8.2 1-13.6-1-4.5-1.7-7.2-2.7-7.4-5.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M459.8 154.4a34.3 34.3 0 0 0-15-16.7l-.2-3.8a50 50 0 0 0 10.1-7.6c17 8 40-3.4 50.6-15.3l4 2.4-2 2.7-2.1-1.1a129.6 129.6 0 0 1-15.2 14.2c3.9 1 9.3 1.7 10.8 1.6 9.4-6.8 16.9-12.9 20.5-13.3l3 4-2.7 2-2.1-1.3a108.7 108.7 0 0 0-26.2 38.8c-6.3-1.4-28.9-.5-33.5-6.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M490 129.2c-1.5-.4-2.8-.8-3.5-1.2a22.7 22.7 0 0 1-12.1 3.4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M460.7 151.9c-1.5-8.4 1-17.8 5.2-20.6a33.6 33.6 0 0 0 34.8-.5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M460.7 147.5c7.2-.2 23 1 26.7 1.5 3.9.6 10.3 2.2 9.4 4.1M464 146.3l2.1-2-2-2.1-2.1 2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M469 104.3c-2.6-3.6-9.8-4.8-11.3 0-.7 2.2-1.7 4.5-3.4 5.5s-1.3 4.1-.6 5.4c1.8 3.3.2 6.5 3.7 8.6 0-2.6 3.9-5.3 7.1-6 3.3-.6 8.3-3.6 9-6.8.6-3.4 1.8-6-4.5-6.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M452.7 136.8h1v6.1l.5.3 5.3-3 .5.7-5.4 3.1v.6l5.4 3-.5.8-5.4-3c-.1.1-.3.3-.5.3v6.2h-.9v-6.2a2 2 0 0 1-.5-.3l-5.3 3.1-.5-.8 5.3-3v-.7l-5.3-3 .5-.8 5.3 3 .5-.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M460.7 151.8a10.7 10.7 0 1 1 .9-14 24 24 0 0 0-1.2 5.7 7.3 7.3 0 1 0-7.3 8c3.4 0 6.3-2.3 7.2-5.4 0 1.4 0 4.6.4 5.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M448.6 162c-.6-.8-1.9-3-1.7-4.5a6 6 0 0 1 3.8 1.5c-.1-1.2-.6-3.6-.3-4.8 1.2.5 3.8 2 4.7 3.6-.2-1.1-.7-4-.2-5.8 1.3.8 3.6 2.9 4 4.4.2-2.3 1-6 1.6-7 1 1 2.6 2 3.6 3.4.2-1.9 1.2-4 2.5-4.5 1 1 2.6 3.7 3 6.6 1-.3 2.3-2 2.9-3 .5 1 1.1 2.5.7 4.5 1.3-1.2 2.8-2.7 3-4.1 1 .7 2.7 2.4 3.1 4.2-.2-1.5 0-4.1-.5-5.6 1.6 1 3 2.5 3.3 4.2.5-1.6 1.5-4.4 2.4-5 .9 1.8 1.8 4 1.7 5.7.6-1.1 1.4-3.2 2.3-3.6.8 1.2.7 4 .5 5.4.8-1.1 2.3-2.5 3.2-3 0 .8.2 2.1 0 3.1a14 14 0 0 0 3.2-5.2c1.6.8 3.2 3.5 3.3 4.9 1.2-.5 3.4-2.5 4-3.6 0 .8.4 3 0 4.6.7-.7 1.3-2 1.7-2.6.4 1.1 0 3.8-.4 5.3a6 6 0 0 1 3.4-1.5 20 20 0 0 1-2.5 7.8c-10.8-3-33.5-4.1-56.3-5.4z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "M486.4 102.3c0-.9 1.8-2.7 5.1-2.7 4 0 7.7 3 10.9 2.7 3.2-.2 1.6.9 1 1.1-.8.3-1.1.7-1 1.2.3.6 0 .9-1.4.4-2.8-1-5.7.4-9.4-.4-3.2-.7-5.1-1-5.2-2.3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M452.1 168.8c-3.3 4-6.7 3.4-7.4.8-.7-2.6 1.8-3.8.9-6.1s1.5-3.3 2.6-2.3 4.8-2.2 6.3 1.2c1.6 3.4 2.8 5.7 2 7-1 1.4-3.7.7-4.4-.6zM466.7 162.7c-.6-1.5 2.9-4.4 4.7-2.3 1.8 2 4.6-2.2 6.2 1 1.6 3.2 2 4.9 2.9 6.7.7 1.8-4.3 2.7-5.9 1.2.2 1-4.4 1.9-5.6-1.2l-2.3-5.4zM490.1 164.6c-.8-1.6 3.3-3.9 5.5-1 .5-1.2 4.6-1.4 4.9 2l.5 6.9c.1 1.3-2.5 2.6-4.3-.9-3.4.7-4.9-1.2-5.3-3.1-.4-2-.8-3-1.3-4z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M454.3 162.3c-.5-1.1 3-3.4 5.2-1.7 2.3 1.7 5.5-1.4 7 1.6 2.7 6.2 2.8 6.6 2 7.8-.8 1.2-4.5.7-5.4-1-.1 1.2-3.3 1-4.9.1-1.8-1-3.1-4.8-3.9-6.8zM478 162.6c-.7-1.8 4.6-3.3 7-.2 1.1-1.1 3.7-1.2 5.1 2.2 1.5 3.3 1.7 5.1.7 6-.8.6-3.5 1-4.4-.5-1.3.8-5.1.1-6-2-.8-2.1-1.5-4-2.3-5.5zM500.5 166c0-1.7 2.8-2.4 3.9 0 1 2.2 4.5.1 4.8 4 0 .7-.4 3.5-1.5 4.9-1 1.3-6.3 0-6.7-2.9l-.5-6z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "M452.1 168.8c-1.2-1.7-2.9-4.4-5-1.5M463.2 169c-.8-.9-1.7-2.5-2-3.7M474.6 169.3c-.8-.6-2-1.7-2.6-2.9M473.6 163.4c2 .2 3.3 2 3.9 2.9.6.8 2 2.4 3 2.5M486.4 170.1c-.7-1-1.4-2-1.5-2.8M485 162.4c.6 1 1.1 1.7 1.5 2.6M496.6 171.6a9.3 9.3 0 0 0-3.5-3.9M496.2 165.4c.1 3.3 4.5 3.6 4.7 6M504.4 166c.4.8.6 1.6.6 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPn);
export default __webpack_public_path__ + "static/media/pn.f46ea786.svg";
export { ForwardRef as ReactComponent };